// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"93":"364afc978a92ca11026e","354":"323e748999f6f0c769e0","5524":"36cc07cba68a27e7a83a","7675":"27749cd487353d0f1c77"}[chunkId] + ".css";
};